import React, { useEffect, useState } from "react";
import { ReactComponent as Play } from "../assets/play.svg";
import { ReactComponent as Volume } from "../assets/volume.svg";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import "../styles/ControlPanel.css";
import { Tooltip } from "react-tooltip";

interface ControlPanelProps {
  isActive: boolean;
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  disabled: boolean;
  inputVolume: number;
  selectedMic: string;
  setSelectedMic: React.Dispatch<React.SetStateAction<string>>;
  micDevices: MediaDeviceInfo[];
}

export default function ControlPanel({
  isActive,
  setIsActive,
  disabled,
  inputVolume,
  selectedMic,
  setSelectedMic,
  micDevices,
}: ControlPanelProps) {
  const [audioLevel, setAudioLevel] = useState(0);

  useEffect(() => {
    if (isActive) {
      const interval = setInterval(() => {
        setAudioLevel(Math.random() * 90 + 10); // Simulated audio level
      }, 100);
      return () => clearInterval(interval);
    } else {
      setAudioLevel(1);
    }
  }, [isActive]);

  useEffect(() => {
    if (disabled && isActive) {
      setIsActive(false);
    }
  }, [disabled]);

  return (
    <div className="control-panel">
      <div className="left-group">
        <button
          disabled={disabled}
          className="play-button"
          data-tooltip-id="button-tooltip"
          data-tooltip-place="bottom"
          data-tooltip-content={disabled ? "You are out of credits" : ""}
          style={{ background: isActive ? "#ff2c2c" : "#04ced9" }}
          onClick={() => setIsActive(!isActive)}
        >
          {isActive ? <div className="pause-icon"></div> : <Play />}
        </button>

        <Tooltip id="button-tooltip" />
        {/* <div className="volume-control">
        <Volume />
        <RangeSlider
          className="single-thumb"
          defaultValue={[0,sliderVolume]}
          min="0"
          max="1"
          step="0.01"
          thumbsDisabled={[true, false]}
          rangeSlideDisabled={true}
          onChange={(e: { target: { value: string; }; }) => setVolume(parseFloat(e.target.value))}
        />
      </div> */}
        <div className="audio-level">
          <div className="audio-level-inner">
            <div
              className="audio-level-bar"
              style={{ width: `${Math.max(inputVolume, 1)}%` }}
            />
          </div>
        </div>
      </div>

      {/* Right Group: Microphone Select */}
      <div className="microphone-select">
        <select
          value={selectedMic}
          onChange={(e) => setSelectedMic(e.target.value)}
        >
          {micDevices.map((device) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Microphone ${device.deviceId}`}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
